// PAGE EVENT
export const GTM_AAB_PAGE_DASHBOARD = () => ({
  pageName: 'loyalty program::all accor business::account::homepage',
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'homepage',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_LOYALTY = () => ({
  pageName: 'loyalty program::all accor business::account::loyalty page',
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'loyalty page',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_BOOKINGS = () => ({
  pageName: 'loyalty program::all accor business::account::bookings',
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'bookings',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_TEAM_MANAGEMENT = () => ({
  pageName: 'loyalty program::all accor business::account::team management',
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'team management',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_COMPANY_SETTINGS = () => ({
  pageName: 'loyalty program::all accor business::account::company settings',
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'company settings',
  clienttype: 'B2B'
})
